<div>
  <div class="form-control" *ngFor="let item of items">
    <div
      class="input-control check-control">
      <input
        id="{{ item.id }}"
        type="checkbox"
        (click)="toggleItem(item)"
      />
      <label for="{{ item.id }}">
        {{ item.item.replace('#EXAMINATION#', 'Post-16 qualification') }}
      </label>
    </div>
  </div>
</div>
<p>You have ticked {{ selectedItems.length }} out of {{ items.length }} which gives you a match of: {{ score }}%</p>



// WEBPACK FOOTER //
// ./src/app/components/_shared/checklist/checklist.component.html